// @ts-nocheck
/* eslint-disable */
export const boldRecordCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.98 1.333A6.67 6.67 0 0 0 1.313 8a6.67 6.67 0 0 0 6.667 6.667A6.67 6.67 0 0 0 14.647 8c0-3.68-2.98-6.667-6.667-6.667M8 10.82c-1.56 0-2.82-1.26-2.82-2.82S6.44 5.18 8 5.18 10.82 6.44 10.82 8 9.56 10.82 8 10.82"/></svg>`,
    name: 'bold-record-circle' as const
};